export default "__VITE_PUBLIC_ASSET__716b28da__"